import { LOCALES } from '@marketplace/i18n';

export const authAgreementDialogI18n = {
  [LOCALES.ENG]: {
    developer_landing_auth_dialog_title: 'Developer Consent',
    developer_landing_auth_dialog_btn_submit: 'OK',
    developer_landing_auth_dialog_btn_cancel: 'Cancel',
    developer_landing_auth_dialog_term1: 'Please download and read the {terms} and our {code}',
    developer_landing_auth_dialog_term2: 'Terms of Service',
    developer_landing_auth_dialog_term3: 'Code of Developer Best Practices',
  },
};
